import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { CarServiceItem } from 'lib/api/carService/types';
import { ServiceForm } from './ServiceForm';
import { IoMdClose } from 'react-icons/io';

const ModalItem = styled.div`
  box-sizing: border-box;
  width: 600px;
  padding: 32px;
  min-height: 208px;
  background-color: #fff;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: ${theme.palette.black_1_100};
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  color: ${theme.palette.black_1_100};
`;

const Content = styled.div`
  margin-top: 16px;
`;

const CloseButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${theme.palette.themeDark50Percent};
  &:hover {
    cursor: pointer;
  }
`;

type Props = {
  serviceData: CarServiceItem;
  handleModalClose: () => void;
  handleSubmit: (data: CarServiceItem) => void;
};

export const ModalServiceDetails = ({
  serviceData,
  handleModalClose,
  handleSubmit,
}: Props) => {
  return (
    <Modal>
      <ModalItem>
        <Header>
          {serviceData.serviceId ? 'Update' : 'Create'} Service
          <CloseButtonWrapper>
            <IoMdClose size={24} onClick={handleModalClose} />
          </CloseButtonWrapper>
        </Header>
        <Content>
          <ServiceForm serviceData={serviceData} handleSubmit={handleSubmit} />
        </Content>
      </ModalItem>
    </Modal>
  );
};
